(function() {

  //全初期化
  const init = function () {
    //---------------------------------------------------------------- 変数・関数 ----------------------------------------------------------------

    //モーダル全体
    const modal = document.getElementById('modal');

    //初回投稿モーダル、SNS シェアモーダル、公開・非公開モーダル、投稿削除モーダル
    const modalSnsShare = document.getElementById('modalSnsShare');
    const modalChangeStatus = document.getElementById('modalChangeStatus');
    const modalDeletePost = document.getElementById('modalDeletePost');
    const modalDeleteSuccess = document.getElementById('modalDeleteSuccess');
    const modalAcceptComment = document.getElementById('modalAcceptComment');

    //ステータス変更チェックボックス・ submit ボタン・メッセージ
    const changeStatusCheckbox = document.getElementById('changeStatusCheckbox');
    const changeStatusButton = document.getElementById('changeStatusButton');
    const changeStatusMessage = document.getElementById('changeStatusMessage');

    //ステータス変更チェックボックス・ submit ボタン・メッセージ
    const changeAcceptCommentCheckbox = document.getElementById('changeAcceptCommentCheckbox');
    const changeAcceptCommentButton = document.getElementById('changeAcceptCommentButton');
    const changeAcceptCommentMessage = document.getElementById('changeAcceptCommentMessage');

    //削除 submit ボタン・メッセージ
    const deleteButton = document.getElementById('deleteButton');
    const deleteMessage = document.getElementById('deleteMessage');

    //編集対象の投稿 ID
    let postId = 0;

    //削除完了フラグ
    let deleteComplete = false;

    //className を持つ祖先を探すが、なければ null を返す
    const _findParent = (className, child) => {
      //自身がクラスを持っていたら返す
      if (child.classList.contains(className)) {
        return child;
      }

      //自身が html 要素なら null　を返す
      if (child instanceof HTMLHtmlElement) {
        return null;
      }

      //そうでなければ親を検索
      return _findParent(className, child.parentElement);
    };

    //モーダルを開く
    const _openModal = target => {
      //対象モーダルの補足
      const targetModal = document.getElementById(target);

      //対象モーダルがあれば表示する
      if (targetModal) {
        targetModal.style.display = 'block';
      }

      //非表示にする
      modal.classList.add('isDsply');
    };

    //モーダルを閉じる
    const _closeModal = () => {
      //削除完了時はリロードする
      if (deleteComplete) {
        window.location.reload();
      }

      //そうでない場合はモーダルを閉じる
      else {
        //非表示にする
        modal.classList.remove('isDsply');

        //全てのモーダルを閉じる
        modalSnsShare.style.display = 'none';
        modalChangeStatus.style.display = 'none';
        modalDeletePost.style.display = 'none';
        modalDeleteSuccess.style.display = 'none';
        modalAcceptComment.style.display = 'none';
      }
    };

    /**
     * サーバーと通信する
     * @param endpoint
     * @param body
     * @returns {Promise<any>}
     * @private
     */
    const _connect = async (endpoint, body) => {
      //サーバーと通信を試みる
      try {
        //サーバーと通知
        const response = await fetch(endpoint, {
          method: 'post',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body
        });

        //レスポンス異常発生
        if ( ! response.ok) {
          //もし 404 だったらログインしていない
          if (response.status === 404) {
            throw new Error('ログインセッションが切れている可能性があります。恐れ入りますがページをリロードして再度ログインしてください。');
          }

          //エラーメッセージが返っているか判定
          const parameter = await response.json();

          //もしエラーメッセージが存在すれば返す
          if ('messages' in parameter && Array.isArray(parameter.messages)) {
            throw parameter.messages;
          }

          //エラーメッセージを文字列に変換して例外を投げる
          throw new Error('エラーが発生しました。しばらくしてから再度お試しください。');
        }

        //パラメータを得る
        const parameter = await response.json();

        //返却
        return parameter;
      }

        //エラーが起きたら文字列の一次元配列に成形してさらに throw する
      catch (error) {
        //恐らく通信途絶
        if (error instanceof TypeError) {
          throw ['ネットワーク接続に失敗しました。'];
        }

        //恐らく意図的な中断
        else if (error instanceof DOMException) {
          throw ['ネットワーク接続が中断されました。'];
        }

        //恐らくサーバーからのメッセージ
        else if (Array.isArray(error)) {
          throw error;
        }

        //恐らくカスタムエラー
        else if (error instanceof Error) {
          throw [error.message];
        }

        //不明
        else {
          throw ['エラーが発生しました。しばらくしてから再度お試しください。'];
        }
      }
    }

    //---------------------------------------------------------------- 絞り込み ----------------------------------------------------------------

    //メニューを開くボタンの捕捉
    const selectButtons = document.getElementsByClassName('js-openSelectMenu');

    //オプションを開くアクションを登録する
    for (let i = 0, max = selectButtons.length; i < max; i = (i + 1) | 0) {
      selectButtons.item(i).addEventListener('click', () => {
        //表示を行う
        //ここで実行を遅らせる理由は、下記オプションを閉じるイベントが全要素のクリックに紐づけられているため、
        //表示しても瞬時にメニューが閉じられるため
        setTimeout(() => {
          //表示対象となるメニューを得る
          const lists = document.getElementsByClassName('js-selectMenu');

          //対象を表示する
          for (let j = 0, listMax = lists.length; j < listMax; j = (j + 1) | 0) {
            lists.item(j).style.display = 'block';
          }
        }, 100);
      });
    }

    //オプションを閉じるアクションを登録する
    document.addEventListener('click', () => {
      //オプションメニューを全て取得
      const menus = document.getElementsByClassName('js-selectMenu');

      //全てのメニューを非表示
      for (let i = 0, max = menus.length; i < max; i = (i + 1) | 0) {
        menus.item(i).style.display = 'none';
      }
    });

    //---------------------------------------------------------------- オプションメニュー ----------------------------------------------------------------

    //オプションを開くボタンの捕捉
    const optionButtons = document.getElementsByClassName('js-openOptionMenu');

    //オプションを開くアクションを登録する
    for (let i = 0, max = optionButtons.length; i < max; i = (i + 1) | 0) {
      optionButtons.item(i).addEventListener('click', event => {
        //a タグの中にあるので、遷移を防ぐ
        event.preventDefault();

        //即時関数で括って変数を固定する
        (() => {
          //currentTarget を固定
          const currentTarget = event.currentTarget;

          //data-id をもっていなければ何もしない
          if ( ! currentTarget instanceof HTMLElement || ! 'id' in currentTarget.dataset) {
            return;
          }

          //表示を行う
          //ここで実行を遅らせる理由は、下記オプションを閉じるイベントが全要素のクリックに紐づけられているため、
          //表示しても瞬時にメニューが閉じられるため
          setTimeout(() => {
            //表示対象となるメニューを得る
            const lists = document.querySelectorAll('.js-optionMenu[data-id="'+currentTarget.dataset.id+'"]');

            //対象を表示する
            for (let j = 0, listMax = lists.length; j < listMax; j = (j + 1) | 0) {
              lists.item(j).classList.add('isDsply');
            }
          }, 100);
        })();
      });
    }

    //オプションを閉じるアクションを登録する
    document.addEventListener('click', () => {
      //オプションメニューを全て取得
      const menus = document.getElementsByClassName('js-optionMenu');

      //全てのメニューから isDsply クラスを削除
      for (let i = 0, max = menus.length; i < max; i = (i + 1) | 0) {
        menus.item(i).classList.remove('isDsply');
      }
    });

    //---------------------------------------------------------------- SNS シェア ----------------------------------------------------------------

    //シェア先の URL を同期させる
    const syncSnsLink = () => {
      //対象を得る
      const links = document.getElementsByClassName('js-snsLink');

      //対象を逐次処理
      for (let i = 0, max = links.length; i < max; i = (i + 1) | 0) {
        //対象が a タグでない、もしくは data-url を持っていなければ何もしない
        if ( ! links.item(i) instanceof HTMLAnchorElement || ! 'url' in links.item(i).dataset) {
          continue;
        }

        //対象の URL を同期
        links.item(i).href = links.item(i).dataset.url+siteUrl+'/place/'+postId;
      }

      //絶えず同期し続ける
      setTimeout(syncSnsLink, 500);
    };

    //同期開始
    syncSnsLink();

    //---------------------------------------------------------------- 公開・非公開 ----------------------------------------------------------------

    //公開・非公開を切り替える
    changeStatusButton.addEventListener('click', async () => {
      //通知 body を生成
      const formData = new FormData();
      formData.append('status', changeStatusCheckbox.checked ? '1' : '3');

      //通知を試みる
      try {
        //更新
        await _connect(siteUrl+'/mypage/change-status/'+postId, formData);

        //更新成功
        window.location.reload();
      }

        //なんらかが失敗
      catch (messages) {
        changeStatusMessage.textContent = messages.join(', ');
      }
    });

    //---------------------------------------------------------------- コメント受付 ----------------------------------------------------------------

    //公開・非公開を切り替える
    changeAcceptCommentButton.addEventListener('click', async () => {
      //通知 body を生成
      const formData = new FormData();
      formData.append('accept_comments_type', changeAcceptCommentCheckbox.checked ? '1' : '0');

      //通知を試みる
      try {
        //更新
        await _connect(siteUrl+'/mypage/accept-comment/'+postId, formData);

        //更新成功
        window.location.reload();
      }

        //なんらかが失敗
      catch (messages) {
        changeAcceptCommentMessage.textContent = messages.join(', ');
      }
    });

    //---------------------------------------------------------------- 削除 ----------------------------------------------------------------

    //公開・非公開を切り替える
    deleteButton.addEventListener('click', async () => {
      //通知を試みる
      try {
        //更新
        await _connect(siteUrl+'/mypage/delete-post/'+postId, null);

        //削除成功につき、モーダルを閉じる動作をページリロードに変更
        deleteComplete = true;

        //更新成功につき、モーダルの内容を切り替える
        modalDeletePost.style.display = 'none';
        modalDeleteSuccess.style.display = 'block';
      }

        //なんらかが失敗
      catch (messages) {
        deleteMessage.textContent = messages.join(', ');
      }
    });

    //---------------------------------------------------------------- モーダルを開く ----------------------------------------------------------------

    //モーダル開くアクションを登録したい DOM を得る
    const modalOpenButtons = document.getElementsByClassName('js-modalOpen');

    //click イベントを購読し、モーダルを開く
    for (let i = 0, max = modalOpenButtons.length; i < max; i = (i + 1) | 0) {
      modalOpenButtons.item(i).addEventListener('click', event => {
        //イベントが起こった要素が data-id, data-target を持っていなかったら何もしない
        if ( ! event.currentTarget instanceof HTMLElement || ! 'id' in event.currentTarget.dataset || ! 'target' in event.currentTarget.dataset) {
          return;
        }

        //投稿 ID を設定
        postId = Number(event.currentTarget.dataset.id);

        //公開設定の同期
        if (event.currentTarget.dataset.target === 'modalChangeStatus' && 'current' in event.currentTarget.dataset) {
          changeStatusCheckbox.checked = Number(event.currentTarget.dataset.current) === 1;
        }

        //コメント受付設定の同期
        if (event.currentTarget.dataset.target === 'modalAcceptComment' && 'current' in event.currentTarget.dataset) {
          changeAcceptCommentCheckbox.checked = Number(event.currentTarget.dataset.current) === 1;
        }

        //モーダルを開く
        _openModal(event.currentTarget.dataset.target);
      });
    }

    //---------------------------------------------------------------- モーダルを閉じる ----------------------------------------------------------------

    //モーダルを閉じるアクションを登録したい DOM を得る
    const modalCloseButtons = document.getElementsByClassName('js-modalClose');

    //click イベントを購読し、モーダルを閉じる
    for (let i = 0, max = modalCloseButtons.length; i < max; i = (i + 1) | 0) {
      modalCloseButtons.item(i).addEventListener('click', event => {
        //モーダルの背景ではなく中身をクリックしていたら何もしない
        if ( ! event.currentTarget.classList.contains('js-modalCloseInner') && _findParent('js-modalInner', event.target)) {
          return;
        }

        //モーダルを閉じる
        _closeModal();
      });
    }
  };

  //初期化イベントを購読
  window.addEventListener('vueReadyInit', init);

})();
